import React from 'react';
import PropTypes from 'prop-types';
import Checkmark from 'components/Checkmark';

export default function Checkbox(props) {
  return (
    <div>
      <label htmlFor={props.value}>
        <div className={`input-main ${props.value} ${props.checked ? 'checked' : ''}`}>
          <Checkmark className="checkmark-icon" fill="#01B48F" stroke="#01B48F" />
        </div>
        <input
          id={props.value}
          value={props.value}
          onChange={props.onChange}
          checked={props.checked}
          type="checkbox"
        />
      </label>

      <style>{`
        label {
          margin: 0 5px 0 0;
        }
        .input-main {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 3px;
          cursor: pointer;
          width: 20px;
          height: 20px;
          border-radius: 3px;
          background-color: transparent;
          border: 1px solid rgba(0, 0, 0, 0.2);
        }
        .input-main .checkmark-icon {
          opacity: 0;
          transition: opacity 0.15s ease-in-out;
        }
        .input-main.checked .checkmark-icon {
          opacity: 1;
        }
        input {
          display: none;
        }
      `}</style>
    </div>
  );
}

Checkbox.defaultProps = {
  onChange: () => {}
};

Checkbox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  checked: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js